// extracted by mini-css-extract-plugin
export default {"chart":"Fjl4Q8TIVWi0jWGTXc9I"};